module.exports = __webpack_public_path__ + "img/kfImage.0dc26b63.jpg";